module.exports = __webpack_public_path__ + "static/assets/544fb4298f84a81a3cbd3371bcca1f36.png";